import axiosClient from "@/api/common/axiosClient.ts";

export const updatePasscode = ({ passcode }: { passcode: string }) => {
  return axiosClient.post<{
    success: true;
    transaction_id: string;
    redirect_url: string;
  }>("users/passcode_update/", {
    ref_code: passcode,
  });
};
